import React from 'react';
import styled from 'styled-components';
import Container from '../atoms/Container';
import PropTypes from 'prop-types';
import { RichText } from "prismic-reactjs";
import ReferralsForm from '../molecules/ReferralsForm';

const Holder = styled.div`
  color: ${props => props.theme.colours.white};
  background-color: ${props => props.theme.colours.gold};
`;
const Inner = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  padding: 5rem 0;
  @media( ${props => props.theme.breakpoints.md} ) { 
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    padding: 4rem 0;
  }
  @media( ${props => props.theme.breakpoints.lg} ) { 
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 1rem;
  }
`;

const Text = styled.div`
  margin-bottom: 1rem;
  @media( ${props => props.theme.breakpoints.lg} ) { 
    grid-column: 1/3;
    margin-bottom: 0;
  }
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
`;

const FormHolder = styled.div`
  @media( ${props => props.theme.breakpoints.lg} ) { 
    grid-column: 4/7;
  }
  input[type="submit"] {
    margin-top: 3rem;
    width: 100%;
    @media( ${props => props.theme.breakpoints.sm} ) { 
      width: auto;  
    }
  }
`;

function ReferralsHolder({text}) {
  return (
    <Holder>
      <Container>
        <Inner>
          <Text>
            <RichText render={text.raw}/>
          </Text>
          <FormHolder>
            <ReferralsForm/>
          </FormHolder>
        </Inner>
      </Container>
    </Holder>
  )
}

ReferralsHolder.propTypes = {
  text: PropTypes.object.isRequired,
};

export default ReferralsHolder;
